import React, { useState } from 'react';
import { TextField, Grid, IconButton, Menu, MenuItem } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';

const RedirectorComponent = ({ selectedServer, demo, showFrame }) => {
  // const [mixedModeToggle, setMixedModeToggle] = useState(false);
  // const [bypassFlashToggle, setBypassFlashToggle] = useState(false);
  // const [preferExternalToggle, setPreferExternalToggle] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentURL, setCurrentURL] = useState(''); // To store the current URL for menu

  const handleClick = (event, url) => {
    setAnchorEl(event.currentTarget);
    setCurrentURL(url); // Set the correct URL based on the clicked button
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openTab = (url) => {
    window.open(url, '_blank');
  };

  // const openFrame = (url = "") => {
  //   showFrame(url);
  // };

  // Mapping of site to market identifier (6 or 71)
  const getMarketMapping = (site) => {
    if (!site) return '';
    return site.endsWith('S') ? '67' : '71';
  };

  const gameId = selectedServer?.game?.launchID || demo;
  const isMobile = selectedServer?.game?.platform === "HTML5 - Mobile";
  // const uglOnly = selectedServer?.market?.uglOnly;
  const marketMapping = getMarketMapping(selectedServer?.site?.name);

  // const redirectorReal = `https://redirector${selectedServer?.site?.redirectorId}.valueactive.eu/Casino/Default.aspx?applicationid=${selectedServer?.market?.appId}&serverid=${selectedServer?.serverId}&gameid=${gameId}&variant=${variant}&authtoken=${selectedServer?.token}&ul=${selectedServer?.language?.shortCode}${mixedMode}${bypassFlash}${preferExternal}`;

  // const redirectorDemo = `https://redirector${selectedServer?.site?.redirectorId}.valueactive.eu/Casino/Default.aspx?applicationid=${selectedServer?.market?.appId}&serverid=${demo}&gameid=${gameId}&variant=${variant}-demo&sext1=demo&sext2=demo&ul=${selectedServer?.language?.shortCode}${mixedMode}${bypassFlash}${preferExternal}`;

  // Build the redirector URL dynamically based on selectedServer data
  const redirectorBaseURL = `https://redirector${marketMapping}.valueadditional.com/Casino/Default.aspx`;
  const redirectorReal = `${redirectorBaseURL}?applicationid=4123&serverid=${selectedServer.serverId}&playmode=real&authtoken=${selectedServer.authToken}&gameid=${gameId}`;
  const redirectorDemo = `${redirectorBaseURL}?applicationid=4123&serverid=${selectedServer.serverId}&playmode=demo&authtoken=${selectedServer.authToken}&gameid=${gameId}`;

  return (
    <div>
      {/* Alerts */}
      {/* {isMobile && !uglOnly && (
        <Typography color="error">
          <b>{selectedServer?.game?.gameId}</b> is an H5 Mobile game, please select a <b>Flash/Desktop</b> game or use the Pathfinder tab to continue.
        </Typography>
      )}
      {uglOnly && (
        <Typography color="error">
          <b>{selectedServer?.market?.name}</b> is a UGL only Market, please select the UGL tab for your Launch links.
        </Typography>
      )} */}

      {/* Main Content */}
      {!isMobile && (
        <>
          {/* <Grid container alignItems="center" justifyContent="flex-end" spacing={3}>
            <Grid item>
              <Typography variant="body2">
                Generate <b>Flash</b> and <b>H5 Desktop</b> launches below. Use the toggles to the right to enable different features.
              </Typography>
            </Grid>
            <Chip
              label="Allow Mixed Mode"
              clickable
              onClick={() => setMixedModeToggle(!mixedModeToggle)}
              color={mixedModeToggle ? "primary" : "default"}
            />
            <Chip
              label="Bypass Flash Prompt"
              clickable
              onClick={() => setBypassFlashToggle(!bypassFlashToggle)}
              color={bypassFlashToggle ? "primary" : "default"}
            />
            <Chip
              label="Prefer External"
              clickable
              onClick={() => setPreferExternalToggle(!preferExternalToggle)}
              color={preferExternalToggle ? "primary" : "default"}
            />
          </Grid> */}

          {/* Form Fields */}
          <Grid container spacing={3} style={{ marginTop: '16px' }}>
            <Grid item xs={12}>
              {/* <label>Real</label> */}
              <TextField
                fullWidth
                variant="outlined"
                value={redirectorReal}
                label="Real"
                helperText="Launch link for live gameplay"
                InputProps={{
                  endAdornment: (
                    <>
                      <IconButton onClick={(e) => handleClick(e, redirectorReal)}>
                        <OpenInNewIcon />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={() => openTab(currentURL)}>
                          <OpenInNewIcon /> Open in New Tab
                        </MenuItem>
                        {/* <MenuItem onClick={() => openFrame(currentURL)}>
                          <OpenInBrowserIcon /> Open in iFrame
                        </MenuItem> */}
                      </Menu>
                    </>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12}>
              {/* <label>Demo</label> */}
              <TextField
                fullWidth
                variant="outlined"
                value={redirectorDemo}
                label="Demo"
                helperText="Launch link for demo gameplay"
                InputProps={{
                  endAdornment: (
                    <>
                      <IconButton onClick={(e) => handleClick(e, redirectorDemo)}>
                        <OpenInNewIcon />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={() => openTab(currentURL)}>
                          <OpenInNewIcon /> Open in New Tab
                        </MenuItem>
                        {/* <MenuItem onClick={() => openFrame(currentURL)}>
                          <OpenInBrowserIcon /> Open in iFrame
                        </MenuItem> */}
                      </Menu>
                    </>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

export default RedirectorComponent;
